<div class="page">
  <div class="login-container">
    <div class="logo-section">
      <img src="{{ BASE_URL }}/web/binary/company_logo" alt="company's logo" />
      <span>{{ 'authentication.b2b_portal' | translate }}</span>
    </div>

    <form class="login-form" [formGroup]="loginForm">
      <h2 class="title">{{ 'authentication.login' | translate }}</h2>

      <ui-form-field data-testid="login-email"
        [fullWidth]="true"
        formControlName="email"
        [label]="'authentication.email' | translate"
        [placeholder]="'authentication.email_placeholder' | translate"
        [type]="'text'"
        [errorMessages]="{
          required: 'validation.required' | translate,
          invalidEmail: 'validation.invalid_email' | translate
        }"
       />

      <ui-form-field data-testid="login-password"
        [fullWidth]="true"
        formControlName="password"
        [label]="'authentication.password' | translate"
        [placeholder]="'authentication.password_placeholder' | translate"
        [type]="passwordVisible ? 'text' : 'password'"
        [suffixIcon]="passwordVisible ? 'eye' : 'eye-close'"
        (suffixIconClick)="togglePasswordVisibility()"
        [errorMessages]="{
          required: 'validation.required' | translate
        }"
       />

      <ui-button data-testid="login-submit"
        type="primary"
        [label]="'common.continue' | translate"
        [fullWidth]="true"
        (click)="loginAction()"
       />

      <span class="forgot-password">
        {{ 'authentication.forgot_password' | translate }}
        <a routerLink="/forget-password">{{ 'authentication.click_here' | translate }}</a>
      </span>
    </form>

    <div class="copyright-section">
      <div class="powered-by">
        <span>{{ 'common.powered_by' | translate }}</span>
        <img class="logo" src="assets/images/logo.svg" alt="volta logo" />
      </div>
      <p>{{ 'authentication.terms_ack' | translate }}</p>
      <div class="links">
        <span
          [innerHTML]="'authentication.rights_reserved' | translate: { year: currentYear }"
        ></span>
        <a href="#">{{ 'common.privacy_policy' | translate }}</a>
        <a href="#">{{ 'common.support' | translate }}</a>
      </div>
    </div>
  </div>
</div>
